import { useState, useEffect, useMemo } from 'react'
import { apiGet } from '../../../../../generic/Api_Functions'
/**
 * Hook for handling widget configuration logic
 * Loads the list of devices and manages filtering
 */
export const useConfiguration = () => {
  const [devices, setDevices] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    let mounted = true
    const loadDevices = async () => {
      setLoading(true)
      try {
        const result = await apiGet('deviceIdCodeNameForUser')
        if (mounted) {
          setDevices(result || [])
          setError(null)
        }
      } catch (err) {
        console.error('Error loading devices:', err)
        if (mounted) setError(err)
      } finally {
        if (mounted) setLoading(false)
      }
    }
    loadDevices()
    return () => { mounted = false }
  }, [])

  const filteredDevices = useMemo(() => {
    if (!searchTerm) return devices
    const lowerTerm = searchTerm.toLowerCase()
    return devices.filter(device =>
      device.name?.toLowerCase().includes(lowerTerm) ||
      (device.code && device.code.toLowerCase().includes(lowerTerm))
    )
  }, [devices, searchTerm])

  return {
    devices: filteredDevices,
    loading,
    error,
    searchTerm,
    setSearchTerm
  }
}
